
<main class="ibox-content  mb-4">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <div class="form-body row" formArrayName="items">
      <h3 *ngIf="itensData?.items.length == 0">Nenhum item para exibir no momento. Por favor, selecione uma secretaria na página de pautas para visualizar os itens correspondentes</h3>
      <mat-accordion [togglePosition]="'before'" class=" mb-2" multi *ngFor="let item of getFormArray(['items'])?.controls; let i = index;trackBy: trackById;" [formGroupName]="i">
        <mat-expansion-panel *ngIf="itensData?.items[i] as currentItem"  [hideToggle]="currentItem.loading == true || currentItem?.acPf?.length == 0">
          <mat-expansion-panel-header class="header-agency">
            <mat-panel-title class="d-flex justify-content-between" [title]="currentItem.loading == false && currentItem?.acPf?.length == 0? 'Esta secretaria não possui projetos.':''">
              <div class="max-title">
                <input type="checkbox" class="me-3" formControlName="checkeds" title="Selecione ao menos um item de Indicador, Entregáveis, Compromisso ou Projetos"/>
                <h3>{{currentItem?.agency?.str_sigla}}<span class="font-weight-normal"> - {{currentItem?.agency?.str_nome}}</span></h3>
              </div>
              <div class="d-flex justify-content-end">
                <mat-spinner *ngIf="currentItem.loading == true" title="Carregando..."></mat-spinner>
                <ng-container *ngIf="currentItem.loading == false && currentItem?.acPf?.length > 0">
                  <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); changeAllCheck(item, true)"
                    alt="Selecionar todos" title="Selecionar tudo">
                    select_check_box
                  </button>
                  <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); changeAllCheck(item, false)"
                    alt="Desselecionar todos" title="Desmarcar tudo">
                    disabled_by_default
                  </button>
                  <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); restartCheck(item, i)"
                    alt="Desselecionar todos" title="Desfazer mudanças">
                    replay
                  </button>
                </ng-container>
              </div>

            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body" *ngIf="currentItem.loading == false && currentItem?.acPf?.length > 0">
            <mat-accordion class="example-headers-align mb-2" [togglePosition]="'before'">
              <mat-expansion-panel class="session" [disabled]="currentItem.loading == true || currentItem?.acPf?.length == 0" [expanded]="true">
                <mat-expansion-panel-header  class="session-title">
                  <mat-panel-title> 
                    <h4>Projetos</h4>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-loading [loader]="currentItem.loading"></app-loading>
                <div class="accordion-body session-body" *ngIf="currentItem?.acPf?.length > 0">
                  <div class="system-table">
                    <div>
                      <app-itens-ac-pf *ngIf="currentItem?.acPf as acPf"
                        [parentFormGroup]="item"
                        [acMeetingType]="itensData?.acMeetingType"
                        [currentItem]="acPf" class="system-table"
                        (checkStatus)="checkStatus(item, $event)"
                      ></app-itens-ac-pf>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <hr class="hr-line-dashed">
    <footer class="form-group row d-flex justify-content-end" *ngIf="itensLoad == 0">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="openModal()">
          <span class="font-icon">check_box</span>
          Conferir itens selecionados
        </button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-primary" type="submit" alt="Salvar reunião">Salvar</button>
      </div>
    </footer>
  </form>
</main>

<ng-template #modal>
  <app-itens-list (closeModal)="closeModal()" [form]="form" [itensData]="itensData" class="itens-list"></app-itens-list>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>